import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, useTheme, Grid } from '@mui/material';
import Slide from '@mui/material/Slide';
import { DateRange } from 'react-date-range';
import { differenceInDays } from 'date-fns';
import ErrorSnackbar from '../../components/ErrorSnackbar';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const AddPackageDialogBox = ({ open, handleCloseDialog, packageData, handleInputChange, handleAddPackage, refetchLicensesData, refetchPackageData, dateRange, setDateRange }) => {
    const theme = useTheme();
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

    // Handle add package
    const handleAddPackageClick = async () => {
        const start = dateRange[0].startDate;
        const end = dateRange[0].endDate;

        const days = differenceInDays(end, start) + 1;

        try {
            await handleAddPackage({
                ...packageData,
                durationInDays: days,
                startDate: start,
                endDate: end,
            });

            setSnackbar({
                open: true,
                message: 'Package added successfully!',
                severity: 'success',
            });

            handleCloseDialog();
            refetchLicensesData();
            refetchPackageData();
        } catch (error) {
            setSnackbar({
                open: true,
                message: 'Error adding package. Please try again.',
                severity: 'error',
            });
            console.error('Error adding package:', error);
        }
    };

    const handleSnackbarClose = () => setSnackbar({ ...snackbar, open: false });

    return (
        <>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                onClose={handleCloseDialog}
                aria-describedby="add-package-dialog-description"
                PaperProps={{
                    sx: {
                        backgroundColor: theme.palette.background.paper,
                        width: '600px',
                        padding: theme.spacing(2),
                    },
                }}
            >
                <DialogTitle sx={{ color: theme.palette.text.white }} variant="h2" fontWeight="bold">
                    Add New Package
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <input autoFocus type="text" name="name" placeholder="Package Name" value={packageData.name} onChange={handleInputChange} style={{ width: '100%', padding: 10 }} />
                        </Grid>
                        <Grid item xs={12}>
                            <input type="text" name="description" placeholder="Description" value={packageData.description} onChange={handleInputChange} style={{ width: '100%', padding: 10 }} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container direction="column" alignItems="center">
                                <Grid item>
                                    <strong style={{ marginBottom: 10, display: 'block', fontSize: '1.1rem' }}>Select Package Duration</strong>
                                </Grid>
                                <Grid item>
                                    <DateRange editableDateInputs={true} onChange={(item) => setDateRange([item.selection])} moveRangeOnFirstSelection={false} ranges={dateRange} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ padding: theme.spacing(2) }}>
                    <Button
                        onClick={handleCloseDialog}
                        variant="contained"
                        sx={{
                            color: theme.palette.text.black,
                            backgroundColor: theme.palette.text.white,
                            fontWeight: 'bold',
                            '&:hover': {
                                backgroundColor: theme.palette.text.white,
                            },
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleAddPackageClick}
                        variant="contained"
                        sx={{
                            color: theme.palette.text.black,
                            backgroundColor: theme.palette.text.white,
                            fontWeight: 'bold',
                            '&:hover': {
                                backgroundColor: theme.palette.text.white,
                            },
                        }}
                    >
                        Add
                    </Button>
                </DialogActions>
            </Dialog>
            <ErrorSnackbar open={snackbar.open} message={snackbar.message} severity={snackbar.severity} onClose={handleSnackbarClose} />
        </>
    );
};

export default AddPackageDialogBox;
